import { Dialog, DialogContent, IconButton } from '@mui/material';
import i18n from '../../utils/i18n';
import CustomButton from './CustomButton';
import AIHeaderClose from '../../images/ai-header-close.svg';

const AffirmationDelete = ({
	openAffirmationDelete,
	setOpenAffirmationDelete,
	title,
	subTitle,
	onConfirmDelete,
}) => {
	const handleCloseAffirmationDelete = () => {
		setOpenAffirmationDelete(false);
	};

	return (
		<Dialog
			open={openAffirmationDelete}
			onClose={handleCloseAffirmationDelete}
			PaperProps={{
				sx: {
					width: '420px',
					height: 'auto',
					maxWidth: 'none',
					borderRadius: '18px',
					overflow: 'hidden',
				},
			}}
			sx={{
				'& .MuiDialog-container': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				'& .MuiDialog-paper': {
					width: '420px',
					maxWidth: 'none',
				},
			}}>
			<IconButton
				aria-label='close'
				onClick={handleCloseAffirmationDelete}
				sx={{
					position: 'absolute',
					top: '8px',
					right: '8px',
					color: '#ffffff',
					padding: '8px',
					userSelect: 'none',
					backgroundColor: 'transparent',
					outline: 'none',
					'&:focus': { outline: 'none' },
					'&:active': { backgroundColor: 'transparent' },
				}}>
				<img
					src={AIHeaderClose}
					alt='AIHeaderClose'
					style={{
						width: '24px',
						height: '24px',
						objectFit: 'contain',
						pointerEvents: 'none',
					}}
				/>
			</IconButton>

			<DialogContent
				sx={{
					padding: '18px',
					height: 'auto',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					overflowY: 'auto',
					scrollbarWidth: 'thin',
					scrollbarColor: '#8791b4 #f1f1f1',
					'&::-webkit-scrollbar': {
						width: '10px',
						backgroundColor: '#f1f1f1',
					},
					'&::-webkit-scrollbar-track': {
						backgroundColor: '#e0e0ff',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: '#8791b4',
						borderRadius: '10px',
						border: '2px solid #e0e0ff',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						backgroundColor: '#6c7493',
					},
				}}>
				<div style={{ width: '100%' }}>
					<div
						style={{
							fontSize: '16px',
							fontWeight: '700',
							color: '#0b0f31',
							margin: '4px 0',
						}}>
						{title}
					</div>
					<div
						style={{
							fontSize: '14px',
							fontWeight: '500',
							color: '#4b5080',
							margin: '4px 0',
						}}>
						{subTitle}
					</div>

					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div style={{ margin: '8px 0' }}>
							<CustomButton
								buttonName={i18n.t('general.undo')}
								onClick={handleCloseAffirmationDelete}
								buttonColor='#ffffff'
								hoverColor='#fafcfe'
								titleColor='#4b5080'
								titleHoverColor='#4b5080'
								width='100%'
								height='44px'
								padding='12px'
							/>
						</div>
						<div style={{ margin: '8px 0' }}>
							<CustomButton
								buttonName={i18n.t('provider.deletecompany')}
								onClick={onConfirmDelete}
								buttonColor='#f64e6c'
								hoverColor='#f2294a'
								titleColor='#ffffff'
								titleHoverColor='#e0e0e0'
								width='100%'
								height='44px'
								padding='12px'
							/>
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default AffirmationDelete;
